// app/javascript/controllers/username_reservation_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "form", 
    "bioAddress", 
    "bioAddressError",
    "email", 
    "emailError",
    "password", 
    "passwordConfirmation", 
    "passwordConfirmationError",
    "termsCheckbox", 
    "submitButton"
  ]

  connect() {
    // Initialize form data and errors
    this.formData = window.gon?.user || {}
    this.formErrors = {}
    this.validationErrors = {
      bioAddress: false,
      email: false,
      password: false
    }
    
    // Set up form validation
    this.validateForm()
  }
  
  validateForm() {
    // Use single event listeners with delegated handlers
    this.formTarget.addEventListener('change', () => this.checkFormValidity())
    this.formTarget.addEventListener('input', () => this.checkFormValidity())
  }
  
  checkFormValidity() {
    const isValid = this.formTarget.checkValidity() && 
                    this.passwordsMatch() && 
                    !this.validationErrors.bioAddress &&
                    !this.validationErrors.email
    
    this.submitButtonTarget.disabled = !isValid
  }
  
  passwordsMatch() {
    return this.passwordTarget.value === this.passwordConfirmationTarget.value
  }
  
  // Generic field validation with common logic
  validateField(field, value, errorTarget, errorKey) {
    if (!value) return
    
    this.validationErrors[field] = false
    const queryParam = field === 'bioAddress' ? 'bio_address' : field
    
    return fetch(`/user-registrations/validate.json?${queryParam}=${encodeURIComponent(value)}`, {
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      }
    })
    .then(response => response.json())
    .then(data => {
      const isValid = data.valid
      const errorMsg = data[errorKey]
      
      if (!isValid) {
        this.validationErrors[field] = true
        this.formErrors[field] = errorMsg
        errorTarget.textContent = errorMsg
        errorTarget.classList.remove('d-none')
        
        // For fields that support setCustomValidity
        if (this[`${field}Target`].setCustomValidity) {
          this[`${field}Target`].setCustomValidity(errorMsg)
        }
      } else {
        errorTarget.classList.add('d-none')
        this.validationErrors[field] = false
        
        // For fields that support setCustomValidity
        if (this[`${field}Target`].setCustomValidity) {
          this[`${field}Target`].setCustomValidity('')
        }
      }
      
      this.checkFormValidity()
      return data
    })
    .catch(error => {
      this.validationErrors[field] = true
      this.checkFormValidity()
    })
  }
  
  validateBioAddress() {
    this.validateField(
      'bioAddress', 
      this.bioAddressTarget.value, 
      this.bioAddressErrorTarget, 
      'bio_address'
    )
  }
  
  validateEmail() {
    this.validateField(
      'email', 
      this.emailTarget.value, 
      this.emailErrorTarget, 
      'email'
    ).then(data => {
      if (data) {
        // Dispatch event so the form can listen to it
        const event = new CustomEvent('email-validation-complete', { 
          detail: { isValid: data.valid },
          bubbles: true 
        })
        this.element.dispatchEvent(event)
      }
    })
  }
  
  checkPasswordMatch() {
    const password = this.passwordTarget.value
    const passwordConfirmation = this.passwordConfirmationTarget.value
  
    if (password !== passwordConfirmation && passwordConfirmation) {
      this.validationErrors.password = true
      this.formErrors.passwordConfirmation = 'Passwords do not match'
      this.passwordConfirmationErrorTarget.textContent = 'Passwords do not match'
      this.passwordConfirmationErrorTarget.classList.remove('d-none')
      this.passwordConfirmationTarget.setCustomValidity('Passwords do not match')
    } else {
      this.passwordConfirmationErrorTarget.classList.add('d-none')
      this.validationErrors.password = false
      this.passwordConfirmationTarget.setCustomValidity('')
    }
  
    this.checkFormValidity()
  }
}